// extracted by mini-css-extract-plugin
module.exports = {"bubbleMessage":"style__bubbleMessage__YPI+4","bubbleText":"style__bubbleText__RrMWk","segmentSizeWrapper":"style__segmentSizeWrapper__V8rIa"};